import { produce } from 'immer';

import { actionTypes } from './constants';
import { TPostCodeFinderState } from './types';

export const defaultState: TPostCodeFinderState = {
    addresses: {},
    findedAddresses: {},
    isLoading: false,
    isLoadingClubsList: false,
    isClubListLoaded: false,
    clubsList: [],
    clubData: {
        name: ''
    },
    geoSearch: {}
};

export const reducer = produce((draftState, action): TPostCodeFinderState | void => {
    switch (action.type) {
        case actionTypes.SET_ADDRESSES: {
            draftState.addresses = {
                ...draftState.addresses,
                ...action.payload
            };
            break;
        }
        case actionTypes.SET_FINDED_ADDRESSES: {
            draftState.findedAddresses = {
                ...draftState.findedAddresses,
                ...action.payload
            };
            break;
        }
        case actionTypes.SET_IS_LOADING_NEAREST_CLUBS: {
            draftState.isLoading = action.payload;
            break;
        }
        case actionTypes.SET_CLUB_DATA: {
            draftState.clubData = action.payload;
            break;
        }
        case actionTypes.SET_CLUBS_LIST: {
            draftState.clubsList = action.payload;
            break;
        }
        case actionTypes.SET_GEO_SEARCH: {
            draftState.geoSearch = {
                ...draftState.geoSearch,
                ...action.payload
            };
            break;
        }
        case actionTypes.SET_IS_CLUB_LIST_LOADED: {
            draftState.isClubListLoaded = action.payload;
            break;
        }
        default:
            break;
    }
}, defaultState);
